"use strict";

var Model = require("../types/Model.js");
var Fetch = require("fetch-ponyfill")({
	Promise: require("promise")
});
var fetch = Fetch.fetch;

var IP_LOOKUP = "https://api.ipify.org/";

var TIME_INTERVAL = 60 * 1000;
var WEATHER_INTERVAL = 30 * 60 * 1000;

module.exports = new Model({
	name: "footer",
	init: init,
	uninit: uninit,
	listeners: listeners,

	update_weather: update_weather,
	update_time: update_time,
	clear_intervals: clear_intervals,
	start_intervals: start_intervals,
	check_can_start: check_can_start,
	get_day: get_day,
	get_month: get_month,
	get_season: get_season,
	get_date: get_date,
	get_short_date: get_short_date,
	get_time: get_time
});

function listeners() {
	return {
		"atouchawaysettings:updated": handle_settings_updated,
		"localization:updated": handle_localization_updated
	};
}

function init() {
	return this.push({
		time: "",
		date: "",
		shortDate: "",
		season: "",
		temperature: "",
		temperature_icon: "",
	});

}

function uninit() {
	this._localization = undefined;
	this._temperature_preference = undefined;
	this.clear_intervals();
}

/**
 * Updates the time display in the footer including:
 * hours, minutes, year, month, day, and season.
 */
function update_time() {
	var time = new Date();
	this.extend({
		time: this.get_time(time),
		date: this.get_date(time),
		shortDate: this.get_short_date(time),
		season: this.get_season(time)
	});
}

/**
 * Updates the weather by getting the info, as a JSON blob, from the
 * Weather Underground website.
 *
 * @return {Object} Parsed weather information and relevant icons.
 */
function update_weather() {
	//need to check temperature preference
	return getIp()
		.then(getWeather.bind(this))
		.then(handle_weather_loaded.bind(this))
		.catch(console.error.bind(console));
}

function getIp(){
	return fetch(IP_LOOKUP)
		.then(function(response){
			return response.text();
		});
}

function getWeather(ip){
	return this.api.weather.getWeather(ip);
}

function handle_weather_loaded(data) {
	var current = data.currently;
	if(!current) return;
	var temp = current.temperature;
	var icon = current.icon;

	var temperature = temp + "°C";
	if (this._temperature_preference === "f")
		temperature = temp + "°F";

	this.extend({
		temperature: temperature,
		temperature_icon: icon
	});
}

function handle_settings_updated(device) {
	var temperature = device.temperature || "c";

	var old_preference = this._temperature_preference;
	this._temperature_preference = temperature;

	this.update_time();
	if (temperature !== old_preference)
		this.update_weather();
	this.check_can_start();
}

function handle_localization_updated(localization) {
	this._localization = localization;
	this.check_can_start();
	this.update_weather();
	this.update_time();
}

function check_can_start() {
	if (this._TIME_INTERVAL) return;
	if (this._WEATHER_INTERVAL) return;
	if (!this._localization) return;
	if (!this._temperature_preference) return;
	this.start_intervals();
}

function start_intervals() {
	this.update_time();
	this.update_weather();
	this._TIME_INTERVAL = setInterval(update_time.bind(this), TIME_INTERVAL);
	this._WEATHER_INTERVAL = setInterval(update_weather.bind(this), WEATHER_INTERVAL);
}

function clear_intervals() {
	clearInterval(this._TIME_INTERVAL);
	clearInterval(this._WEATHER_INTERVAL);
	this._TIME_INTERVAL = undefined;
	this._WEATHER_INTERVAL = undefined;
}

function get_time(time) {
	var minutes = pad_number(time.getMinutes());
	var raw_hours = time.getHours();
	var hours;

	var localization = this._localization;
	if (!localization) return;

	var language = localization.language;

	if (language === "en") {
		hours = raw_hours;
		if (raw_hours > 12) hours = raw_hours - 12;
		if (raw_hours === 0) hours = 12;
		return pad_number(hours) + ":" + minutes + " " + ((raw_hours >= 12) ? "PM" : "AM");
	}
	return pad_number(raw_hours) + ":" + minutes;
}

function get_date(time) {
	var localization = this._localization;
	if (!localization) return;
	var language = localization.language;
	var date = time.getDate();
	var year = time.getFullYear();

	if (language === "fr") {
		return this.get_day(time) + " " + date + " " + this.get_month(time) + " " + year;
	} else {
		return this.get_day(time) + ", " + this.get_month(time) + " " + date + ", " + year;
	}
}

function get_short_date(time) {
	return time.getDate() + "/" + (time.getMonth() + 1) + "/" + time.getFullYear();
}

function get_season(time) {
	var localization = this._localization;
	if (!localization) return;
	var month = time.getMonth();
	var date = time.getDate();
	var season_names = localization.localization.seasons;

	var seasons = {
		0: function () {
			return (month === 0) || (month === 1) || ((month === 11) && (date >= 21)) || ((month === 2) && (date < 21));
		},
		1: function () {
			return (month === 9) || (month === 10) || ((month === 11) && (date < 21)) || ((month === 8) && (date >= 21));
		},
		2: function () {
			return (month === 3) || (month === 4) || ((month === 5) && (date < 21)) || ((month === 2) && (date >= 21));
		},
		3: function () {
			return (month === 6) || (month === 7) || ((month === 5) && (date >= 21)) || ((month === 8) && (date < 21));
		}
	};

	var season = Object.keys(seasons).reduce(function (p, key) {
		if (p) return p;
		if (seasons[key]()) return key;
	}, null);

	return season_names[season];
}

function get_month(time) {
	var localization = this._localization;
	if(!localization) return;
	var month = time.getMonth();

	var months = localization.localization.months;

	var monthData = months[month];
	if ((typeof monthData) === "string") return monthData;
	return monthData.text;
}

function get_day(time) {
	var localization = this._localization;
	if(!localization) return;

	var day = time.getDay();

	var days = localization.localization.days;

	return days[day];
}

function pad_number(number) {
	if (number < 10) {
		return "0" + number;
	}
	return "" + number;
}
